module.exports = __webpack_public_path__ + "media/packs/images/flags/BB-006f6d37e23147ca709b5ff93c75e58f.svg";